/**
 * 模块说明
 * 作用： 该模块主要作用提供  ‘新建文档’、‘新建表格’、‘新建WPS Word’、‘新建WPS Excel’、‘新建文件’、‘从模版新建’入口
 * createDoc createWPSWord createWPSExcel createSpreadsheet TemplateCreate 这些文件是对应的实现。
 * 创建文件的方法是在父组件里，但是有的父组件Home页面没有这个方法，是因为Home就不夹创建文件。
 */
import React, { Dispatch, SetStateAction, useContext, useState, useMemo, useCallback } from "react";
import { Menu, Button, Dropdown, message } from "antd";
import UploadButton from "../UploadBox/UploadButton";
import UploadFolderButton from "../UploadBox/UploadFolderButton";
import "./index.less";
import context, { useTranslation } from "../../context";
import folderPng from "@/assets/img/folder.png";
import uploadFilePNG from "@/assets/img/upload-file.png";
import openTemplateModal from "./createDocumentByTemplate";
import openAICreateModal from "./AICreate";
import { createDocumentByPageType, PageType, pageTypeNumber } from "./utils";
import { isFocusEnv } from "@/utils";
// import openTemplateModal from './CreateByTemplate';
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import IconFont from "@/components/icon";
import Bus from "@/utils/bus";
import {
  createTemplatePageInSpace,
  createTemplateTableInSpace,
  pageTypes
} from "../../api/createmenu";
import { openModalTextBox } from "../ModalTextBox";
import api from "../../api";
import events from "@/components/Joyspace/context/events";
import { addToken, dateFormat, getJoySpaceAI, notUseJoySpaceOffline, openLink } from "../../util";
import { analysisLog } from "@/utils/logAnalytics";
import { ActionFnEnum, ActionType, FileType, MenusType } from "../../types";
import { useNavigator } from "@/utils/NetworkCheck";
import { getFullTime } from "../../controllers/JoyspaceController";
import { folderType } from "../../config/permissions.config";
import { useLocation } from "react-router-dom";
import templatePng from "@/assets/img/template.png";
import AICreateIcon from "@/assets/img/AI.png";
interface IProps {
  canCreateFolder?: boolean;
  canCreatePage?: boolean;
  space?: () => void;
  team?: () => void;
  category?: () => void;
  lowCode?: (url: string) => void;
  disabledCreateFolder?: boolean;
  zhuanban?: {
    teamId: string;
    spaceId: string;
    selectfolder?: {
      id: string;
      name: string;
    };
    setIsReload?: Dispatch<SetStateAction<boolean>>;
    projectId: string;
    archive?: boolean;
  };
  folderId?: string;
  reloadListCallback?: Dispatch<SetStateAction<boolean>>;
  gid?: string; // 组空间id
  from?: string;
}
// eslint-disable-next-line complexity
export default function (props: IProps) {
  const {
    folderId,
    reloadListCallback,
    gid,
    canCreateFolder = true,
    canCreatePage = true,
    disabledCreateFolder = false,
    from = ""
  } = props;
  const lang = useTranslation();
  const canCreateFile = canCreatePage;
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { appRuntimeEnv, onLine } = globalContext;
  const location = useLocation();
  const { currentRouterInfo } = useContext(context);
  const [disabled, setDisabled] = useState(false);
  const urlPrefix = appRuntimeEnv.joyspaceHost;
  const canCreateSheet = appRuntimeEnv.canCreateSheet;
  const addFileInfo = useCallback(
    async (folderId: string, type: FileType, info: any) => {
      const id = info?.id;
      if (!id || !type) {
        console.error("id or type not null");
        return;
      }
      if (notUseJoySpaceOffline() || onLine) {
        if (gid) {
          events.emit("list.reload", { folderId });
          events.emit("list.check");
          return;
        }
        // 由于新建排序时会有问题统一采取刷新，离线新建无排序始终放在最上面
        if (currentRouterInfo?.level === 0 && type === FileType.Folder) {
          events.emit("list.reload", { folderId, type: ActionType.Folder });
          return;
        }
        if (currentRouterInfo?.level === 0 && type === FileType.Page) {
          events.emit("list.reload", { folderId, type: ActionType.Page });
          return;
        }
        if (typeof currentRouterInfo?.level === "undefined") {
          events.emit("list.reload", { folderId });
          return;
        }
        return;
      }
      let res = { ...info };
      res.updated_at = getFullTime(res.updated_at);
      res.created_at = getFullTime(res.created_at);
      res.openTime = getFullTime(res.openTime);
      res.isExist = true;
      events.emit("list.partial.refresh", {
        changeData: { newItem: res, type: ActionFnEnum.ADD },
        folderId: folderId,
        withOutSave: true,
        key: MenusType.SPACE
      });
    },
    [currentRouterInfo?.level, gid, onLine]
  );
  useMemo(() => {
    if ((notUseJoySpaceOffline() || gid) && !onLine) {
      setDisabled(true);
      return;
    }
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  // 创建各种文档
  const createDocument = (type: string) => {
    createDocumentByPageType(type, folderId || "", gid || "", currentRouterInfo?.name)
      .then((res: any) => {
        console.log(res, "createDocument=====>", type);
        if (!res) {
          message.error(lang("common.fail"));
          return;
        }
        analysisLog(
          "xtbg_joyspace_create_page",
          "click",
          from,
          type,
          res.id,
          folderId || gid || ""
        );
        // analysisLog("xtbg_jzb_joyspace_home_1676548210761", "39", type, from, res.id || "");
        addFileInfo(folderId || "", FileType.Page, res);
        if (!useNavigator.onLine) {
          setTimeout(() => {
            openLink(res, urlPrefix);
          }, 600);
        } else {
          openLink(res, urlPrefix);
        }
      })
      .catch((err: any) => {
        message.error(lang("common.fail"));
      });
  };
  // 创建模板文档
  const createTemplateInSpaceFn = (id = "", pageType?: number) => {
    if (pageType === 4) {
      createTemplateTableInSpace({
        folderId: folderId === "root" ? "" : folderId,
        templateId: id
      })
        .then((res) => {
          analysisLog(
            "xtbg_joyspace_templateLib_1688719461025",
            "3",
            folderId ? folderId : "root",
            res.id
          );
          if (!res) {
            message.error(lang("common.fail"));
            return;
          }
          addFileInfo(folderId === "root" ? "" : folderId || "", FileType.Page, res);
          // reloadListCallback?.((oldvalue) => !oldvalue);
          // window.open(`${urlPrefix}/${pageTypes[res.page_type]}/${res.id}`);
          openLink(res, urlPrefix);
          Bus.emit("joyspace:documentCreated", res);
        })
        .catch(() => {
          message.error(lang("common.fail"));
        });
    } else {
      createTemplatePageInSpace({
        folderId: folderId === "root" ? "" : folderId,
        templateId: id
      })
        .then((res) => {
          if (!res) {
            message.error(lang("common.fail"));
            return;
          }
          addFileInfo(folderId === "root" ? "" : folderId || "", FileType.Page, res);
          // reloadListCallback?.((oldvalue) => !oldvalue);
          // window.open(`${urlPrefix}/${pageTypes[res.page_type]}/${res.id}`);
          openLink(res, urlPrefix);
          Bus.emit("joyspace:documentCreated", res);
        })
        .catch(() => {
          message.error(lang("common.fail"));
        });
    }
  };
  // 通过模版创建
  const createDocumentByTemplate = (pageType: number) => {
    if (notUseJoySpaceOffline() || useNavigator.onLine) {
      openTemplateModal({
        globalContext,
        pageType,
        isJoyspace: true,
        canCreateSheet,
        callback: (id: string, pageType: number) => {
          // 没有id时，创建空白文档/表格
          if (!id) {
            return createDocument(pageType === 1 ? PageType.page : PageType.sheet);
          }
          analysisLog("xtbg_jzb_joyspace_home_1676548210761", "39", "page", from, id || "");
          createTemplateInSpaceFn(id, pageType);
          if (!useNavigator.onLine) {
            message.error(lang("common.fail"));
          }
        }
      });
    } else {
      createDocument(pageType === 1 ? PageType.page : PageType.sheet);
    }
  };
  // 创建脑图
  const createMind = (type: any) => {
    if (notUseJoySpaceOffline() || useNavigator.onLine) {
      // analysisLog("xtbg_joyspace_templateLib_1688719461025", "1");
      createDocument(PageType.mind);
    }
  };
  // 模板库
  const openTemplateLib = () => {
    if (notUseJoySpaceOffline() || useNavigator.onLine) {
      analysisLog("xtbg_joyspace_templateLib_1688719461025", "1");
      openTemplateModal({
        globalContext,
        title: "模板库",
        isJoyspace: true,
        canCreateSheet,
        callback: (id: string, pageType: number) => {
          // 没有id时，创建空白文档
          if (!id) {
            return createDocument(pageType === 1 ? PageType.page : PageType.sheet);
          }
          createTemplateInSpaceFn(id, pageType);
          if (!useNavigator.onLine) {
            message.error(lang("common.fail"));
          }
        }
      });
    }
  };
  const isHomePage = useMemo(() => {
    console.log("location.pathname", location.pathname);
    if (/home/.test(location.pathname)) {
      return true;
    }
    return false;
  }, [location.pathname]);
  // AI创作
  const openAICreateLib = () => {
    if (notUseJoySpaceOffline() || useNavigator.onLine) {
      analysisLog("xtbg_joyspace_templateLib_1688719461025", "1");
      openAICreateModal({
        globalContext,
        callback: () => {}
      });
    }
  };
  // 创建文件夹
  const createFolder = () => {
    openModalTextBox({
      title: lang("c.categoriesPicker.create"),
      onOk: (value, close) => {
        api.categories.create(folderId || "", value).then((res) => {
          if (res?.data) {
            // tree数据更新
            // reloadListCallback?.((oldvalue) => !oldvalue);
            addFileInfo(folderId || "", FileType.Folder, res.data);
            // 文档左侧导航更新
            // events.emit("freshLeftTreeByFolderById", folderId || "");
            message.success(lang("common.success"));
            close();
          } else {
            message.error(res.status || lang("common.fail"));
          }
        });
      }
    });
  };
  const menu = (
    <Menu className="joyspace-create-menu">
      {/* 创建 文档 */}
      <Menu.Item
        // data-name="doc"
        data-name={!isFocusEnv() && disabled ? "notdoc" : "doc"}
        disabled={isFocusEnv() ? false : disabled}
        onClick={() => createDocumentByTemplate(pageTypeNumber.PAGE)}
        clstag="pageclick|keycount|focus_joyspace_01_1615797631505|9"
      >
        {lang("c.CreateMenu.createDoc")}
      </Menu.Item>
      {/* 创建 表格 */}
      {canCreateSheet && (
        <Menu.Item
          data-name={!isFocusEnv() && disabled ? "notspreadsheet" : "spreadsheet"}
          disabled={isFocusEnv() ? false : disabled}
          // onClick={() => createDocument(PageType.sheet)}
          onClick={() => createDocumentByTemplate(pageTypeNumber.SHEET)}
          log-analysis-data={`xtbg_jzb_joyspace_home_1676548210761|39|sheet|${from}`}
        >
          {lang("c.CreateMenu.createSpreadsheet")}
        </Menu.Item>
      )}
      {!disabled && (
        <Menu.Item
          data-name="mind"
          onClick={() => createMind(pageTypeNumber.MIND)}
          // clstag="pageclick|keycount|focus_joyspace_01_1615797631505|26"
        >
          {lang("c.CreateMenu.createMind")}
        </Menu.Item>
      )}
      {
        // 通过ducc配置wpsTarget来控制 joyspaceWpsTarget
      }
      {/* 创建 WPS Word */}

      {appRuntimeEnv?.joyspaceWpsTarget === "private" && (
        <Menu.Item
          data-name={disabled ? "notwpsdoc" : "wpsdoc"}
          disabled={disabled}
          onClick={() => createDocument(PageType.wpsWord)}
          clstag="pageclick|keycount|focus_joyspace_01_1615797631505|11"
        >
          {lang("c.CreateMenu.createWPSWord")}
        </Menu.Item>
      )}
      {/*  创建 WPSExcel */}
      {appRuntimeEnv?.joyspaceWpsTarget === "private" && (
        <Menu.Item
          data-name={disabled ? "notwpsspreadsheet" : "wpsspreadsheet"}
          disabled={disabled}
          onClick={() => createDocument(PageType.wpsexcel)}
          clstag="pageclick|keycount|focus_joyspace_01_1615797631505|12"
        >
          {lang("c.CreateMenu.createWPSExcel")}
        </Menu.Item>
      )}
      {/*  创建 WPSPPT */}
      {appRuntimeEnv?.joyspaceWpsTarget === "private" && (
        <Menu.Item
          data-name={disabled ? "notwpsppt" : "wpsppt"}
          disabled={disabled}
          onClick={() => createDocument(PageType.wpsPPT)}
          clstag="pageclick|keycount|focus_joyspace_01_1615797631505|12"
        >
          {lang("c.CreateMenu.createWPSPPT")}
        </Menu.Item>
      )}
      {/* 京办暂时关闭低代码 */}
      {/* {isFocusEnv() && props.lowCode && (
                <Menu.Item
                    data-name="lowCode"
                    onClick={() => props?.lowCode?.(appRuntimeEnv.joyspaceLowCode.createUrl)}
                >
                    {lang('c.CreateMenu.createLowCode')}
                </Menu.Item>
            )} */}
      {/* {props.space && (
                <Menu.Item
                    data-name="space"
                    onClick={() => props?.space?.()}
                    clstag="pageclick|keycount|focus_joyspace_01_1615797631505|13"
                >
                    {lang('c.CreateMenu.createSpace')}
                </Menu.Item>
            )}
            {props.team && (
                <Menu.Item
                    data-name="team"
                    onClick={() => props?.team?.()}
                    clstag="pageclick|keycount|focus_joyspace_01_1615797631505|14"
                >
                    {lang('c.CreateMenu.createTeam')}
                </Menu.Item>
            )} */}
      {/* 创建文件夹 */}
      {canCreateFolder && (
        <Menu.Item
          disabled={disabled}
          onClick={createFolder}
          log-analysis-data={`xtbg_jzb_joyspace_home_1676548210761|39|folder|${from}`}
        >
          <img src={folderPng} className="iconic-folder" />
          {lang("c.CreateMenu.createCategory")}
        </Menu.Item>
      )}
      {/* <Menu.Item
                data-name="templateCreate"
                onClick={() => templateCreate(globalContext, currentRouteInfo, zhuanban)}
                clstag="pageclick|keycount|focus_joyspace_01_1615797631505|15"
            >
                从模版新建
            </Menu.Item> */}
    </Menu>
  );
  const uploadMenu = useMemo(() => {
    // 共享根目录
    if (currentRouterInfo?.id === folderType.SHARE) {
      return (
        <UploadFolderButton
          folderId={folderId}
          spaceId={gid}
          gid={gid}
          from={from}
          archive={!onLine}
        />
      );
    }
    // 无权限或者离线
    if (!(canCreateFile || canCreateFolder) || !onLine) {
      return (
        <Button type="primary" disabled={true} className="upload-btn">
          {lang("myspace.upload")}
          <IconFont className="down" type="iconicon_down" />
        </Button>
      );
    }
    return (
      <Dropdown
        overlay={() => {
          return (
            <div className="joyspace-upload-menu ant-dropdown-menu">
              <div className="joyspace-menu-item">
                <UploadButton
                  archive={!canCreateFile || !onLine}
                  folderId={folderId}
                  spaceId={gid}
                  gid={gid}
                  from={from}
                >
                  <span className="icon-span">
                    <img src={uploadFilePNG} className="iconic-upload-file" />
                  </span>
                </UploadButton>
              </div>
              <div className="joyspace-menu-item">
                <UploadFolderButton
                  archive={!(canCreateFile || canCreateFolder) || !onLine}
                  folderId={folderId}
                  spaceId={gid}
                  gid={gid}
                  from={from}
                >
                  <span className="icon-span">
                    <img src={folderPng} className="iconic-folder" />
                  </span>
                </UploadFolderButton>
              </div>
            </div>
          );
        }}
        placement="bottomRight"
      >
        <Button
          type="default"
          disabled={!onLine}
          // clstag="pageclick|keycount|focus_joyspace_01_1615797631505|5"
          className="upload-btn"
        >
          {lang("myspace.upload")}
          <IconFont className="down" type="iconicon_down" />
        </Button>
      </Dropdown>
    );
  }, [canCreateFile, folderId, gid, from, lang, onLine, currentRouterInfo, canCreateFolder]);
  // console.log(canCreateFile, 'canCreateFilecanCreateFilecanCreateFile');
  return (
    <div className="joyspace-create">
      {isFocusEnv() && isHomePage && getJoySpaceAI() && (
        <Button
          type="default"
          disabled={!canCreateFile || !onLine}
          onClick={openAICreateLib}
          className="aiCreate-btn"
        >
          <img src={AICreateIcon} />
          {lang("AICreate")}
        </Button>
      )}
      {!gid && (
        <Button
          type="default"
          disabled={!canCreateFile || !onLine}
          onClick={openTemplateLib}
          className="template-btn"
        >
          <img src={templatePng} />
          {lang("Template Library")}
        </Button>
      )}

      {uploadMenu}
      {!canCreateFile && canCreateFolder && (
        <Button
          type="primary"
          disabled={disabledCreateFolder || disabled}
          log-analysis-data={`xtbg_jzb_joyspace_home_1676548210761|39|folder|${from}`}
          className="create-btn"
          onClick={createFolder}
        >
          {lang("c.CreateMenu.createCategory")}
        </Button>
      )}
      {!canCreateFile && !canCreateFolder && (
        <Button disabled type="primary" className="create-btn">
          {lang("c.CreateMenu.create")}
          <IconFont className="down" type="iconicon_down" />
        </Button>
      )}
      {canCreateFile && (
        <Dropdown overlay={menu} placement="bottomRight">
          <Button
            type="primary"
            clstag="pageclick|keycount|focus_joyspace_01_1615797631505|5"
            className="create-btn"
          >
            {lang("c.CreateMenu.create")}
            <IconFont className="down" type="iconicon_down" />
          </Button>
        </Dropdown>
      )}
    </div>
  );
}
